module.exports = __webpack_public_path__ + "static/fonts/greenmile/tasktype/fonts/tasktype.eot";